import type { CSSProperties } from 'react';
import { useTheme } from 'styled-components';

export const CHECK_VARIANT_KEYS = {
  DEFAULT: 1,
  CIRCLED: 2,
  FILLED_CIRCLE: 3,
  FILLED_CIRCLE_REVERSE: 4,
} as const;

type PropsType = {
  overrideStyle?: CSSProperties;
  variant?: Values<typeof CHECK_VARIANT_KEYS>;
};

const CheckIcon = ({
  overrideStyle = {},
  variant = CHECK_VARIANT_KEYS.DEFAULT,
}: PropsType) => {
  const theme = useTheme();
  switch (variant) {
    case CHECK_VARIANT_KEYS.DEFAULT:
      return (
        <svg
          style={{ width: '15px', height: '11px', ...overrideStyle }}
          viewBox="0 0 15 11"
        >
          <path
            fill={overrideStyle.color || theme.primaryColor}
            d="M13.087.667A.998.998 0 1114.5 2.08l-8.494 8.617a.998.998 0 01-1.411 0L.292 6.906a.998.998 0 011.412-1.412L5.3 8.578l7.788-7.91z"
          />
        </svg>
      );
    case CHECK_VARIANT_KEYS.CIRCLED:
      return (
        <svg
          fill="none"
          style={{ width: '64px', height: '64px', ...overrideStyle }}
          viewBox="0 0 64 64"
        >
          <path
            stroke={overrideStyle.stroke || theme.Grey7}
            strokeWidth="4"
            d="M62 32c0 16.569-13.431 30-30 30C15.431 62 2 48.569 2 32 2 15.431 15.431 2 32 2c10.423 0 19.605 5.313 24.985 13.388A29.85 29.85 0 0162 32z"
          />
          <path
            stroke={overrideStyle.stroke || theme.primaryColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="4"
            d="M22.6 33.703l5.634 5.52L40 27.33"
          />
        </svg>
      );
    case CHECK_VARIANT_KEYS.FILLED_CIRCLE_REVERSE:
      return (
        <svg
          style={{ width: '30px', height: '30px', ...overrideStyle }}
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
            fill={theme.primaryColor}
          />
          <path
            d="M11 15.2292L13.6517 18L19 12"
            stroke={theme.white}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case CHECK_VARIANT_KEYS.FILLED_CIRCLE:
      return (
        <svg
          style={{ width: '22px', height: '22px', ...overrideStyle }}
          viewBox="0 0 22 22"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM15.2432 9.88875C15.6337 9.49822 15.6337 8.86506 15.2432 8.47453C14.8527 8.08401 14.2195 8.08401 13.829 8.47453L10.3987 11.9048L8.97957 10.4857C8.58904 10.0952 7.95588 10.0952 7.56535 10.4857C7.17483 10.8763 7.17483 11.5094 7.56535 11.9L9.69157 14.0262C10.0821 14.4167 10.7153 14.4167 11.1058 14.0262L15.2432 9.88875Z"
            fill={overrideStyle.color || theme.primaryColor}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default CheckIcon;
